import { template as template_db404ac50b874924b27abec618c917cc } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
export default class BiPanelTaskTags extends Component {
    @service
    taskRepo;
    @service
    intl;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.tags?.length > 0;
        this.args.initParam('tags', this.args.tags);
    }
    @action
    onChange(tags) {
        this.args.updateParam('tags', tags);
    }
    get tags() {
        return [
            ...new Set(this.taskRepo.tasks.flatMap((_task)=>_task.tags))
        ].toSorted();
    }
    get selectedTags() {
        return this.args.getParam('tags') ?? this.args.tags;
    }
    get selectedTagsBadgeText() {
        return this.args.createSearchBadgeText('tags', 'tags', 'criteria.selectedTags');
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_db404ac50b874924b27abec618c917cc(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-task-tags-criteria"
        @class="align-items-end"
        @form={{@form}}
        @label="reportTags"
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.selectedTags}}
        ...attributes
      >
        <div class="input-group">
          <div class="col">
            <div class="row">
              <div class="col">
                <@form.element
                  class="tag-select"
                  @controlType="power-select-multiple"
                  @value={{this.selectedTags}}
                  @options={{this.tags}}
                  @onChange={{this.onChange}}
                as |el|>
                  <el.control
                    class="sm"
                    @searchEnabled={{true}}
                    @searchField="text"
                    @placeholder={{t "biPanel.tags.placeholder"}}
                  />
                </@form.element>
              </div>
            </div>
          </div>
        </div>
      </FilterWrapper>
    </Portal>

    <Portal @target="search-badge-tags">
      <SearchTag
        @isDisplayed={{@tags}}
        @text={{this.selectedTagsBadgeText}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
